export const PAYLOAD_FORMATS = [
  { id: 'XML', displayValue: 'XML' },
  { id: 'JSON', displayValue: 'JSON' },
  { id: '*', displayValue: '*' },
];
